import React from 'react';

import { LayoutContent, LayoutRoot } from 'components/mui/Layouts/components/Layout';
import { AppBarDocument, AppBarItemDivider } from 'components/mui/Layouts/components/AppBar';
import BackToArrow from 'components/mui/Layouts/Document/components/BackToArrow';
import AppbarLogoCompany from 'components/mui/Layouts/components/AppbarLogoCompany';
import Box from '@mui/material/Box';
import FullscreenIconButton from 'components/mui/Layouts/components/FullscreenIconButton';
import EventsHistoryIconButton from 'components/mui/Layouts/components/EventsHistoryPanel/EventsHistoryIconButton';
import HelpDropdown from 'components/mui/Layouts/components/HelpDropdown';
import LocaleSelect from 'components/mui/LocaleSelect';
import ApplicationDropdown from 'components/mui/Layouts/components/ApplicationDropdown';
import AccountDropdown from 'components/mui/Layouts/components/AccountDropdown';
import Stack from '@mui/material/Stack';
import { DrawerHeader } from 'components/mui/Layouts/components/Drawer';
import PaymentNavigation from 'pages/dokkaPay/pages/payment/components/PaymentNavigation';
import ChatLauncher from 'components/mui/Layouts/components/Chat';

const LayoutPayPayment = ({ children, backTo }) => {
  return (
    <LayoutRoot>
      <AppBarDocument>
        <Box flexShrink={0} display="flex" alignItems="center">
          <BackToArrow href={backTo} />
          <AppbarLogoCompany />
        </Box>
        <PaymentNavigation />
        <Stack direction="row" alignItems="center" spacing={1} flexShrink={0}>
          <FullscreenIconButton />
          <AppBarItemDivider />
          <EventsHistoryIconButton />
          <ChatLauncher />
          <HelpDropdown />
          <LocaleSelect flagOnly />
          <ApplicationDropdown />
          <AccountDropdown />
        </Stack>
      </AppBarDocument>

      <LayoutContent sx={{ height: '100vh' }}>
        <DrawerHeader />
        {children}
      </LayoutContent>
    </LayoutRoot>
  );
};

export default LayoutPayPayment;
